import {useLocation, useNavigate, useParams} from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { GetVehicleWithDocumentById } from '../../../../../reduxToolkit/EmployeeContractors/EmployeeContractorsApi';
import {useCallback, useEffect, useMemo, useState} from 'react';
import { errorMsg } from '../../../../../Apis/functions';
import {
    getColumnsVehicleDetailsProvider,
    getSectionsVehicleDetailsProvider
} from '../../../../Dashboard/Contractors/Model/Models';
import { USER_TYPE_MODEL } from '../../../../../enums/userTypeEnum';
import { TABLES } from '../../../../../Apis/Tables';
import { MODELS } from '../../../../../Apis/Models';
import {GetProviderVehicleDetail} from '../../../../../reduxToolkit/Providers/providersApi';

/**
 * @Author: Cecilia López Martínez
 * @JobTitle: Full Stack Developer - IBL
 * @Email: clopez@ibl.mx
 */
const VehicleDetailsDocumentationApp = (
    {
        userType
    }
) => {

    const { id } = useParams();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const {state} = location;
    const tableId = `tbl_vdd_vehicle_documentation`;
    const option = `${TABLES.VEHICLE_ACCESS_LOG}`;
    const moduleId = `${MODELS.VehicleAccessLog}`;
    const [expandedRowId, setExpandedRowId] = useState(null);
    const [elementDetails, setElementDetails] = useState();

    useEffect(() => {
        getDetails();
    }, [id]);

    const getDetails = () => {
        if (!id) return;

        const actionByType = {
            [USER_TYPE_MODEL.CONTRACTOR_IN_CHARGE]: GetVehicleWithDocumentById,
            [USER_TYPE_MODEL.SUPPLIER_IN_CHARGE]: GetProviderVehicleDetail,
        };

        const action = actionByType[userType];
        if (!action) return;

        dispatch(action(id)).then(({ payload: { data: { data, success, code } } }) => {
            if (success === true) setElementDetails(data);
            else errorMsg(code);
        });
    }

    const handleRowExpand = (row) => {
        if (row?.id !== expandedRowId) {
            setExpandedRowId(row?.id);
        }
    };

    const columns = useMemo(() =>
            getColumnsVehicleDetailsProvider(t, moduleId, option, id),
        [t, moduleId, option, id]
    );

    const sections = useMemo(() =>
            getSectionsVehicleDetailsProvider({
                userTypeId: userType,
                id,
                option
            }),
        [userType, id, option]
    );

    const renderExpandedRow = useCallback(({ row }) => row.content(), []);

    const goBack = () => {
        if(state?.backUrl){
            navigate(state.backUrl?.pathname || state.backUrl, { state: { currentSubView: state?.currentSubView || undefined}});
        }
    };


    return {
        t,
        tableId,
        elementDetails,
        handleRowExpand,
        columns,
        sections,
        renderExpandedRow,
        goBack
    };

};

export default VehicleDetailsDocumentationApp;
